import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppSettings } from '../common/config';

export interface WordpressContentResponse {
  slug: string;
  title: string;
  content: string;
  link: string;
}

const WORDPRESS_CONTENT_ENDPOINT = AppSettings.API_SERVER + '/smart-response/api/wordpress-content';

@Injectable({
  providedIn: 'root',
})
export class WordpressContentService {
  constructor(private http: HttpClient) {}

  getContent(pathUrl: string): Observable<WordpressContentResponse> {
    const params = new HttpParams().set('pathUrl', pathUrl);

    return this.http.get<WordpressContentResponse>(WORDPRESS_CONTENT_ENDPOINT, { params });
  }

  getAboutUsContent(): Observable<WordpressContentResponse> {
    return this.getContent('about-us');
  }
}
